<script>
import {eventBus} from "../../main";

import Swal from "sweetalert2";
import _ from "lodash";

export default {
  props: {
    fileTypes: {
      type: Array,
      default: () => [],
    },
    autoIncrement: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      progreso: 0,
      tipo: '',
      file: null,
      name: null,
      imageUrl: null,
      typeFile: null,
      loader: false,
      isHovered: false,
      urlDir: "",
      injectData: {},
      guardando: false,
    };
  },
  beforeDestroy() {
    eventBus.$off("GuardandoContenidoSoporte");
  },
  async mounted() {
    eventBus.$on("GuardandoContenidoSoporte", async (ack, url) => {
      this.urlDir = url
      try {
        const uploadedUrl = await this.onUpload();
        ack.resolve(uploadedUrl); // <- notifica que terminó exitosamente
      } catch (error) {
        ack.reject(error); // <- notifica error
      }
    });
  },
  computed: {
    isFile() {
      return !!this.file;
    },
    fileBackground() {
      if (this.file) {
        let backgroundImage = this.imageUrl ? `url("${this.imageUrl}")` : "";
        return {
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      }
      return {};
    }
  },
  methods: {
    handleMouseLeave() {

      this.isHovered = false;
    },
    quitarTildesYEspacios(input) {
      let sinTildes = _.deburr(input);
      return sinTildes.replace(/\s+/g, "");
    },
    restaurar() {
      this.file = null;
      this.imageUrl = null;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    handleDrop(event) {
      const selectedFile = event.dataTransfer.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    validateAndProcessFile(selectedFile) {
      if (this.fileTypes.includes(selectedFile.type) && selectedFile.name.split(".").length <= 2) {
        this.tipo = selectedFile.name.split(".")[1]
        this.file = selectedFile;
        this.typeFile = this.file.name.substring(
            this.file.name.lastIndexOf(".")
        );
        this.name = this.file.name;
      }
      else {
        if (!this.fileTypes.includes(selectedFile.type)) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Tipo de archivo no válido.",
            confirmButtonText: "Aceptar",
          });
        }
        if (selectedFile.name.split(".").length > 2) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "El nombre del archivo no puede contener puntos.",
            confirmButtonText: "Aceptar",
          });
        }
        this.file = null;
        this.imageUrl = null;
      }
      this.$refs.fileInput.value = "";
    },
    async onUpload() {
      try {
        if (this.file != null) {
          // el usuario va a subir archivo
          let nameFileT = this.$moment.tz(new Date(), 'America/Bogota')
              .format('DDMMYYYYHHmmss') + Math.floor(Math.random() * (1 - 99999 + 1)) + 1;
          this.loader = true;

          const newPath = this.quitarTildesYEspacios(this.urlDir);
          const lastDirectory = newPath.substring(newPath.lastIndexOf("/") + 1);
          const filename = `${lastDirectory}_${nameFileT}${this.typeFile}`;
          const urlImg = newPath.split("/").join("|");

          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("remoteFilePath", urlImg);
          formData.append("FileName", filename);

          let isSave = await this.$store.dispatch("hl_post_file_axios", {
            path: "CargaMultimedia/UploadFile",
            data: formData,
            onProgress: (percent) => {
              this.progreso = percent;
              if (percent === 100) this.guardando = true;
            },
          });

          if (isSave.respuesta) {
            this.tipo = null;
            this.file = null;
            this.typeFile = []
            this.name = null;
            return "https://www.helexiumfiles.com/" + newPath + "/" + filename;
          } else {
            return "NoVideo";
          }
        } else {
          await Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se ha seleccionado ningún archivo.",
            confirmButtonText: "Aceptar",
          });
        }
      }
      catch (error) {
        //this.$isLoading(false);
        await Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message,
          confirmButtonText: "Aceptar",
        });
      }
      finally {
        this.loader = false;
        this.guardando = false;
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="onUpload">
    <div v-if="progreso > 0 && progreso < 100" style="width: 100%; padding: 0 1rem; margin-top: 1rem;">
      <progress :value="progreso" max="100" style="width: 100%"></progress>
      <div class="text-center text-white mt-1">{{ progreso }}%</div>
    </div>
    <div v-if="guardando" class="text-center mt-2" style="width: 100%; padding: 0 1rem; margin-top: 1rem;">
      Guardando contenido...
    </div>
    <slot name="header"> </slot>
    <input type="file" @change="handleFileChange" ref="fileInput" style="display: none" />
    <div class="dropzone" :class="{ 'is-file': isFile }" :style="fileBackground" @click="triggerFileInput"
         @drop.prevent="handleDrop" @dragover.prevent @dragenter.prevent @mouseover="isHovered = true"
         @mouseleave="handleMouseLeave">
      <div v-if="loader" class="loader"></div>
      <div class="overlay" v-if="imageUrl"></div>
      <div v-if="!file" class="d-flex flex-column align-items-center">
        <i :class="[
          'fas fa-cloud-arrow-up text-white-50',
          isHovered && 'fa-beat',
        ]" style="font-size: 2rem"></i>
        <br />
        Haz clic o arrastra un archivo aquí.
      </div>
      <div v-else class="d-flex flex-column align-items-center" style="z-index: 3">
        <i :class="`fas fa-file-circle-check ${loader && 'fa-bounce'}`" style="font-size: 2rem"></i>
        <br />
        <span>
          El documento "
          <span class="text-primary font-weight-bold">{{ name }}</span> " ha
          sido cargado
        </span>
      </div>
    </div>
    <slot name="prevFooter"> </slot>
  </form>
</template>

<style scoped>
form {
  width: 100%;
  min-height: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dropzone {
  width: 100%;
  min-height: 150px;
  height: 80%;
  border: 2px dashed #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  transition: 0.3s all;

  &:hover {
    background-color: #ececec;
  }

  .dark &:hover {
    background-color: #131416;
  }
}

.is-file {
  background-color: #ececec;

  .dark & {
    background-color: #131416;
  }
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;

  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
}

.actions {
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
